import { useState } from "react";
import { InputProps } from "../types";

const Input = ({
  type,
  className,
  placeholder,
  label,
  name,
  value,
  onChange,
  disabled,
  maxLength,
  ref,
}: InputProps) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="input-container-blk">
      <input
        type={type}
        className={className}
        placeholder={placeholder}
        value={value}
        name={name}
        onChange={onChange}
        required
        aria-required="true"
        disabled={disabled}
        id={name}
        autoComplete="off"
        maxLength={maxLength}
        ref={ref}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      {label && (
        <label htmlFor={name} className="label">
          {isFocused ? "Email Address" : label}
          <span aria-hidden="true">*</span>
        </label>
      )}
    </div>
  );
};

export default Input;
